import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";

const RoleBasedRoute = ({ allowedRoles, children }) => {
  const role = useSelector((state) => state.auth.role);

  if (!allowedRoles.includes(role.roleName)) {
    // Redirect to unauthorized page if role is not allowed
    return <Navigate to="/unauthorized" />;
  }

  return children;
};

export default RoleBasedRoute;
